const androidPackageId = process.env.VUE_APP_ANDROID_PACKAGE_ID || ''
const iosAppId = process.env.VUE_APP_IOS_APP_ID || ''

export const OpenUrlEnum = {
  GOOGLE_PLAY: `https://play.google.com/store/apps/details?id=${androidPackageId}`,
  IOS_APP_STORE: `https://apps.apple.com/app/${iosAppId}`
}

export const UniversalPathEnum = {
  UNIVERSAL_LINK: process.env.VUE_APP_UNIVERSAL_LINK_PATH || 'universal-link'
}
